import { useState, useRef } from 'react';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';
import Icons from './icons';


const CopyToClipboard = ({ textToCopy, placement, hideAfter }) => {
    const [isCopied, setisCopied] = useState(false);
    const target = useRef(null);

    const copyLinkToClipboard = () => {
        navigator.clipboard.writeText(textToCopy)
        setisCopied(true)
        setTimeout(() => {
            setisCopied(false)
        }, hideAfter || 1000);
    }

    return (
        <span title='Copy' style={{ cursor: "pointer" }}>
            <span ref={target} 
                className="mx-2 d-inline-block"
                onClick={copyLinkToClipboard}>
                <Icons.CopyIcon />
            </span>

            <Overlay target={target.current} show={isCopied} placement={placement || "top"}>
                <Tooltip>Copied!</Tooltip>
            </Overlay>
        </span>
    )
}

export default CopyToClipboard